<template>
  <div class="main">
    <date></date>
    <div class="headerTop"></div>
    <backBtn></backBtn>
    <div class="activeTitle" style="margin-top: 60px">标准化建设</div>
    <div class="shequ">
      <div class="box">
        <div class="icontitle">
          <img src="../../assets/images/index_ico_dang@2x.png" alt="" />
          <span class="tabsTitle"> 社区党组织、小区（网格）党组织</span>
        </div>

        <div class="bzhWrapper">
          <div class="one">
            <img style="width: 25px; height: 44px" src="../../assets/images/img_1@2x.png" alt="" />
          </div>
          <div class="table">
            <sqList />
          </div>
        </div>
      </div>

      <div class="plus1">
        <img style="width: 28px; height: 28px" src="../../assets/images/img_+@2x.png" alt="" />
      </div>

      <div class="starandContent">
        <div class="three">
          <img style="width: 25px; height: 44px; margin-left: 60px" src="../../assets/images/img_3@2x.png" alt="" />
        </div>
        <div class="all">
          <div class="tabs-box">
            <div class="tabs">
              <div :class="starand == 1 ? 'active' : 'tabsItem'" @click="strandCLick(1)">
                <div style="text-align: center">
                  <img class="iconImg" :src="tabsurl1" alt="" />
                  <span class="tabsTitle"> {{ xqzzName ? xqzzName : '小区自治组织' }} </span>
                </div>
              </div>
              <div :class="starand == 2 ? 'active' : 'tabsItem'" @click="strandCLick(2)">
                <div style="text-align: center">
                  <img class="iconImg" :src="tabsurl2" alt="" />
                  <span class="tabsTitle"> 物业服务企业</span>
                </div>
              </div>
              <div :class="starand == 3 ? 'active' : 'tabsItem'" @click="strandCLick(3)">
                <div style="text-align: center">
                  <img class="iconImg" :src="tabsurl3" alt="" />
                  <span class="tabsTitle">社会组织</span>
                </div>
              </div>
            </div>
          </div>

          <xqList @xqzzMc="getName" v-if="starand == 1" />
          <wyList v-if="starand == 2" />
          <shList v-if="starand == 3" />

        </div>
      </div>

      <div class="plus1">
        <img style="width: 28px; height: 28px" src="../../assets/images/img_+@2x.png" alt="" />
      </div>

      <div style="position: relative">
        <div class="more">
          <div class="n">
            <img style="width: 28px; height: 44px; margin: 50px 0 0 55px" src="../../assets/images/img_N@2x.png"
              alt="" />
          </div>
          <div class="tabs_">
            <div class="tabs_item" @click="n_click(item)" v-for="(item, index) in nlist" :key="index">
              {{ item.shzzmc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四项制度  多元评价 -->
    <div class="construct">
      <div class="system">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;制度建设
        </div>
        <div class="system1" style="margin-top: 20px">
          <table style="width: 100%">
            <colgroup>
              <col width="70%" />
              <col width="30%" />
            </colgroup>
            <tr @click="zdjsInfo(item, '当前位置-首页-制度建设详情')" v-for="(item, index) in dataList1">
              <td style="text-align: left">{{ item.zdmc }}</td>

              <td style="text-align: right">
                {{ item.sj && item.sj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList1.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
        </div>

        <div class="yema2">
          <Pagination v-show="query2.total > 0" :total="query2.total" :limit.sync="query2.pageSize"
            :currentPageSize="query2.pageSize" :page.sync="query2.pageNum" round="false"
            layout="total, sizes, prev, pager, next, jumper" @pagination="changeZdjs" />
        </div>
      </div>
      <div class="view">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;评价监督
        </div>
        <div class="system1" style="margin-top: 30px">
          <table>
            <colgroup>
              <col width="70%" />
              <col width="30%" />
            </colgroup>
            <tr @click="dypjInfo(item, '当前位置-首页-评价监督详情')" v-for="(item, index) in dataList2" :key="index">
              <td style="text-align: left">{{ item.bt }}</td>

              <td style="text-align: right">
                {{ item.sj && item.sj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList2.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
        </div>

        <div class="yema2">
          <Pagination v-show="query3.total > 0" :total="query3.total" :currentPageSize="query3.pageSize"
            :limit.sync="query3.pageSize" :page.sync="query3.pageNum" round="false"
            layout="total, sizes, prev, pager, next, jumper" @pagination="changePjjd" />
        </div>
      </div>
    </div>
    <div class="yezhu">
      <div class="owner">
        <div class="systemTitle" style="width:50%">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业主服务
        </div>
        <div class="service">
          <div class="item" @click="handlerService(1)">
            <img src="../../assets/images/index_ico_gxkj@2x.png" alt="" />
            <span> 共享空间</span>
          </div>
          <div class="item" @click="handlerService(2)">
            <img src="../../assets/images/index_ico_hswy@2x.png" alt="" />
            <span> 红色物业</span>
          </div>
          <div class="item" @click="handlerService(3)">
            <img src="../../assets/images/index_ico_cthd@2x.png" alt="" />
            <span> 常态活动</span>
          </div>
        </div>
        <div class="service">
          <div class="item noitem" @click="handlerService(4)">
            <img src="../../assets/images/index_ico_zxgn@2x.png" alt="" />
            <span> 造血功能</span>
          </div>
          <div class="item noitem" @click="handlerService(5)">
            <img src="../../assets/images/index_ico_zhpt@2x.png" alt="" />
            <span> 智慧平台</span>
          </div>
          <div class="item noitem" @click="handlerService(6)">
            <img src="../../assets/images/index_ico_dkxc@2x.png" alt="" />
            <span> 党课宣传</span>
          </div>
        </div>
      </div>
    </div>

    <div class="yezhu">
      <div class="owner">
        <div class="systemTitle" style="width:50%">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;评先评优
        </div>
        <viewTable></viewTable>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialog" width="80%">
      <contain class="container" v-if="dialog" :currentData="currentData"></contain>
    </el-dialog>

    <el-dialog title="当前位置-首页-六有服务" :visible.sync="dialogVisible" width="80%">
      <el-tabs @tab-click="tabsClick" :tab-position="tabPosition" v-model="activeName" style="height: 300px">
        <el-tab-pane label="用户管理" v-for="(item, index) in tabsList" :key="item.name" :label="item.name"
          :name="item.label">
          <table style="width: 100%">
            <colgroup>
              <col width="70%" />
              <col width="30%" />
            </colgroup>
            <tr @click="hdInfo(item)" v-for="(item, index) in dataList6">
              <td style="text-align: left; color: #fff; height: 35px">
                {{ item.hdmc }}
              </td>
              <td style="text-align: right; color: #fff">
                {{ item.hdkssj && item.hdkssj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList6.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
          <Pagination v-show="innerQuery.total > 0" :total="innerQuery.total" :limit.sync="innerQuery.pageSize"
            :page.sync="innerQuery.pageNum" :currentPageSize="innerQuery.pageSize" round="false"
            layout="total, sizes, prev, pager, next, jumper" @pagination="tabChange" />
        </el-tab-pane>
      </el-tabs>

      <el-dialog width="80%" :title="innerTitle" :visible.sync="innerVisible" append-to-body>
        <contain class="container" v-if="innerVisible" :currentData="currentData"></contain>
      </el-dialog>

    </el-dialog>

    <!-- N详情 -->
    <el-dialog title="当前位置-首页-社会组织列表" :visible.sync="zzVisible" width="80%" v-if="zzVisible">
      <el-tabs @tab-click="ntabsClick" :tab-position="tabPosition" v-model="nactiveName" style="height: 300px">
        <el-tab-pane v-for="(item, index) in nlist" :key="item.shzzmc" :label="item.shzzmc" :name="item.fileId">
          <table style="margin: 20px 0 20px 0">
            <colgroup>
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
            </colgroup>
            <tr align="center" style="font-size: 600; background-color: #0e59cb">
              <td>姓名</td>
              <td>照片</td>
              <td>政治面貌</td>
              <td>党内党支部职务</td>
              <!-- <td>出生年月</td>
              <td>性别</td> -->
            </tr>

            <tr align="center" v-for="(item, index) in nTabList" :key="index">
              <td>{{ item.xm }}</td>
              <td>
                <span v-if="item.zp">
                  <img :src="item.zp" alt="" />
                </span>

                <span v-else>
                  <img src="../../assets/images/img_null_headimg.png" alt="" />
                </span>
              </td>

              <td>{{ item.zzmm }}</td>
              <td>{{ item.zw }}</td>
            </tr>

            <tr v-if="!nTabList.length" align="center">
              <td colspan="6">暂无数据</td>
            </tr>
          </table>
          <Pagination v-show="queryn.total > 0" :total="queryn.total" :limit.sync="queryn.pageSize"
            :currentPageSize="queryn.pageSize" :page.sync="queryn.pageNum" round="false"
            layout="total, sizes, prev, pager, next, jumper" @pagination="changeN" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import backBtn from "../../components/back/index.vue";
import url1 from "../../assets/images/index_ico_dang_sel.png";
import url2 from "../../assets/images/index_ico_dang_nor.png";
import url3 from "../../assets/images/index_ico_wgw_nor.png";
import url4 from "../../assets/images/index_ico_wgw_sel.png";
import viewTable from "../Table/viewTable.vue";
import api from "@/api/starand.js";
import detail from "@/api/detail.js";
import date from "../../components/header/index.vue";
import contain from "../../components/detail/index.vue";
import wyqyId from "../../config";

import sqList from "./sqList";
import xqList from "./xqList";
import wyList from "./wyList";
import shList from "./shList";

export default {
  name: "",
  components: {
    backBtn,
    viewTable,
    date,
    contain,
    sqList,
    xqList,
    shList,
    wyList
  },
  data() {
    return {

      xqzzName: '',

      dialogTitle: "",
      innerVisible: false,
      zzVisible: false,
      innerTitle: "",
      dialogVisible: false,
      active: 1,
      dialog: false,
      starand: 1,
      infoList: [],
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      queryn: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query1: {
        total: 0,
        pageNum: 1,
        pageSize: 4,
      },
      query2: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query3: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },

      innerQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 8,
      },
      ntabsList: [],
      tabsurl1: url1,
      tabsurl2: url3,
      tabsurl3: url2,
      nlist: [],
      currentData: {
        zhwyFileEntityList: [],
      },
      dataList1: [{ id: 1 }],
      dataList2: [],
      dataList3: [],
      tabPosition: "left",
      serviceType: "",
      activeName: "1",
      nactiveName: "",
      tabsList: [
        {
          name: "共享空间",
          label: "1",
        },
        {
          name: "红色物业",
          label: "2",
        },
        {
          name: "常态活动",
          label: "3",
        },
        {
          name: "造血功能",
          label: "4",
        },
        {
          name: "智慧平台",
          label: "5",
        },
        {
          name: "党课宣传",
          label: "6",
        },
      ],
      dataList6: [],
      nTabList: [],
      pdfFlag: false,
    };
  },
  created() { },
  mounted() {
    this.initShzz();

    this.initheader();
    this.initZdjs();
    this.initPjjd();
  },
  methods: {

    getName(name) {
      this.xqzzName = name;
    },


    //社会组织
    initShzz() {
      api.shzzlist().then((res) => {
        if (res.data.code == 200) {
          this.nlist = res.data.data;
          this.nactiveName = res.data.data[0].fileId;
        }
      });
    },
    dypjInfo(item, title) {
      this.dialog = true;
      this.dialogTitle = title;
      let params = {
        id: item.id,
        lx: item.lx,
      };
      detail.pjjdinfo(params).then((res) => {
        if (res.data.code == 200) {
          this.currentData = res.data.data;
        }
      });
    },
    zdjsInfo(item, title) {
      this.dialog = true;
      this.dialogTitle = title;
      let params = {
        id: item.id,
        lx: 3,
      };
      detail.listinfo(params).then((res) => {
        if (res.data.code == 200) {
          this.currentData = res.data.data;
        }
      });
    },

    // 标准化小区建设
    strandCLick(val) {
      this.query1.pageNum = 1;
      this.query1.total = 0;

      if (val == 1) {
        this.tabsurl1 = url1;
        this.tabsurl2 = url3;
        this.tabsurl3 = url2;
      } else if (val == 2) {
        this.tabsurl1 = url2;
        this.tabsurl2 = url4;
        this.tabsurl3 = url2;
      } else {
        this.tabsurl1 = url2;
        this.tabsurl2 = url3;
        this.tabsurl3 = url1;
      }
      this.starand = val;
      // this.initheader();
    },
    initheader() {
      let params = {
        ...this.query1,
        wyqyId: wyqyId,
        lx: this.starand,
      };
      api.zzrylist(params).then((res) => {
        if (res.data.code == 200) {
          this.infoList = res.data.data.list;
          this.query1.total = res.data.data.total;
        }
      });
    },
    // 生产环境
    findCharIndex(str, char, num) {
      var index = str.indexOf(char);
      for (var i = 0; i < num - 1; i++) {
        index = str.indexOf(char, index + 1);
      }
      let endurl =
        "http://182.140.144.130:9000" + str.substr(index, str.length);
      return endurl;
    },
    changeHeader(val) {
      this.query1.pageNum = val;
      this.initheader();
    },

    changeZdjs(val) {
      this.query2.pageNum = val;
      this.initZdjs();
    },

    //四项制度
    initZdjs() {
      let params = {
        ...this.query2,
        wyqyId: wyqyId,
      };
      api.bzhjszdjslist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList1 = res.data.data.list;
          this.query2.total = res.data.data.total;
        }
      });
    },
    changePjjd(val) {
      this.query3.pageNum = val;
      this.initPjjd();
    },
    // 多元评价
    initPjjd() {
      let params = {
        ...this.query3,
        wyqyId: wyqyId,
      };
      api.pjjdlist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList2 = res.data.data.list || [];
          this.query3.total = res.data.data.total;
        }
      });
    },
    tabChange(val) {
      this.innerQuery.pageNum = val;
      let params = {
        wyqyId: wyqyId,
        hdlx: this.activeName,

        ...this.innerQuery,
      };
      api.bzhjsyzfwlist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList6 = res.data.data.list;
          this.innerQuery.total = res.data.data.total;
        }
      });
    },
    tabsClick(val) {
      this.innerQuery.pageNum = 1;
      let params = {
        wyqyId: wyqyId,
        hdlx: val.name,

        ...this.innerQuery,
      };
      api.bzhjsyzfwlist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList6 = res.data.data.list;
          this.innerQuery.total = res.data.data.total;
        }
      });
    },

    //六有服务
    handlerService(type) {
      this.activeName = String(type);
      this.dialogVisible = true;
      this.serviceType = type;
      this.innerQuery.pageNum = 1;
      let params = {
        wyqyId: wyqyId,
        hdlx: type,
        ...this.innerQuery,
      };
      api.bzhjsyzfwlist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList6 = res.data.data.list;
          this.innerQuery.total = res.data.data.total;
        }
      });
    },
    hdInfo(item) {
      this.innerTitle = "详情";
      this.innerVisible = true;
      let params = {
        id: item.id,
        lx: 4,
      };
      detail.listinfo(params).then((res) => {
        if (res.data.code == 200 && res.data.data) {
          this.currentData = res.data.data;
        }
      });
    },
    n_click(item) {
      this.zzVisible = true;
      this.nactiveName = item.fileId;

      // let params = {
      //   fileId: this.nactiveName,
      //   ...this.queryn,
      // };

      let params = {
        id: item.id,
        ...this.queryn,
      };

      api.shzzrylist(params).then((res) => {
        if (res.data.code == 200) {
          this.nTabList = res.data.data.list;
          this.queryn.total = res.data.data.total;
        }
      });
    },
    ntabsClick(val) {
      this.queryn.pageNum = 1;
      this.nactiveName = val.name;
      let params = {
        fileId: this.nactiveName,
        ...this.queryn,
      };
      api.shzzrylist(params).then((res) => {
        if (res.data.code == 200) {
          this.nTabList = res.data.data.list;
          this.queryn.total = res.data.data.total;
        }
      });
    },
    changeN(val) {
      this.queryn.pageNum = val;
      let params = {
        fileId: this.nactiveName,
        ...this.queryn,
      };
      api.shzzrylist(params).then((res) => {
        if (res.data.code == 200) {
          this.nTabList = res.data.data.list;
          this.queryn.total = res.data.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.shequ {
  position: relative;
  min-height: 544px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 24px 24px 24px 24px;
  border: 2px solid #70e2ee;

  margin-top: 40px;
  padding: 20px;
}

.bzhWrapper {
  padding: 20px;
  display: flex;
  align-items: center;

  .one {
    width: 150px;
  }

  .table {
    width: 0;
    flex: 1;
  }
}



.box {
  // height: 72px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 12px;
  border: 2px solid #70e2ee;
}

.one {
  // position: absolute;
  left: 100px;
  width: 25px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icontitle {
  width: 300px;

  height: 52px;
  line-height: 52px;
  text-align: center;
  border: 1px solid #2e82ff;
  border-radius: 5px;
  margin: 0 auto;
  background: #1b87ff;
  margin-top: 8px;

  img {
    width: 16px;
    height: 16px;
    // vertical-align: middle;
  }

  .tabsTitle {
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    color: #fff;
  }
}

.starandContent {
  min-height: 403px;
  padding: 20px;
  padding-bottom: 0;
  margin-top: 10px;
  display: flex;
  position: relative;

  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 12px;

  border: 2px solid #70e2ee;

  .three {
    width: 150px;
    padding-top: 140px;
  }

  .all {
    flex: 1;
    position: relative;

    .tabs-box {
      width: 100%;

      .tabs {
        height: 44px;
        border: 1px solid #07397c;
        border-radius: 4px;
        padding: 3px;
        display: flex;
        border-image: linear-gradient(136deg,
            rgba(58.73301140964031, 151.39451622962952, 250.44643074274063, 1)) 2 2;
        border-radius: 8px;
        border: 2px solid #3b97fa;

        .tabsItem {
          width: 50%;
          cursor: pointer;
          border: 1px solid transparent;
          border-radius: 8px;
          &:hover {
            border: 1px solid #2e82ff;
          }

          img {
            // left: ;
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }

          .tabsTitle {
            text-align: center;
            font-size: 16px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 700;
            color: #83a9da;
            line-height: 40px;
          }
        }

        .active {
          width: 50%;
          border: 1px solid #2e82ff;
          cursor: pointer;
          border-radius: 6px;
          background-color: #0c3e81;

          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }

          .tabsTitle {
            text-align: center;
            font-size: 16px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 700;
            color: #fff;
            line-height: 40px;
          }
        }
      }
    }
  }
}

.starandContent table {
  table-layout: fixed;
  width: 100%;
  margin: 0;
  border-spacing: 0;
}

.starandContent table tr:nth-child(even) {
  //   background-color: #0f53a5;
}

.starandContent table td {
  height: 39px;
  border: 1px solid #105db4;
}

.starandContent table td img {
  width: 47px;
  height: 47px;
}

.construct {
  display: flex;
  margin-top: 40px;

  .system {
    position: relative;
    flex: 1;
    margin-right: 20px;
    width: 49%;
    height: 411px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;

    .systemTitle {
      width: 100%;
      height: 27px;
      line-height: 27px;
      font-weight: 700;
      color: #ffffff;
      font-size: 16px;
      background: url("../../assets/images/index_titlesmall_bg@2x.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .view {
    position: relative;
    flex: 1;
    height: 411px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;

    .systemTitle {
      width: 100%;
      height: 27px;
      line-height: 27px;
      font-weight: 700;
      color: #ffffff;
      font-size: 16px;
      background: url("../../assets/images/index_titlesmall_bg@2x.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}

.construct .view .system1 table {
  table-layout: fixed;
  width: 100%;
  margin: 0;
  border-spacing: 0;
}

.system1 table tr {
  background-color: transparent !important;
  cursor: pointer;
}

.system1 table td {
  height: 50px !important;
  line-height: 50px !important;
  border: none;
  border-bottom: 1px solid #07397c;
  cursor: pointer;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.service {
  display: flex;

  .item {

  display: flex;
  align-items: center;

  justify-content: center;

    flex: 1;
    text-align: center;
    height: 54px;
    margin: 10px 20px 20px 0;
    border-radius: 6px;
    background: linear-gradient(180deg, rgba(52, 176, 253, 0) 0%, #345cfd 99%);
    border-radius: 5px;
    cursor: pointer;

    border: 1px solid;
    border-image: linear-gradient(180deg,
        rgba(255, 255, 255, 0.30000001192092896),
        rgba(255, 255, 255, 0)) 1 1;

    img {
      width: 24px;
      height: 24px;
      // line-height: 54px;
      // vertical-align: middle;
      margin-right: 5px;
    }

    span {
      color: #ffffff;
      font-weight: 600;
      font-size: 18px;
      line-height: 54px;
    }
  }
}

.noitem {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.public {
  padding: 20px;
  border: 1px solid #2e82ff;
  margin: 20px;
}

.wxzj {
  display: flex;
  margin-top: 20px;

  .wxzjItem {
    flex: 1;
    display: flex;

    .icon {
      width: 120px;
      height: 120px;
    }

    .info {
      flex: 1;
      margin-top: 50px;

      .info-title {
        height: 24px;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        line-height: 24px;
      }

      .info-num {
        height: 36px;
        font-size: 24px;
        font-family: Barlow, Barlow;
        font-weight: 600;
        color: #2eff82;
        line-height: 36px;

        .num1 {
          color: #2eff82;
          font-size: 16px;
          font-weight: 600;
          font-family: "fontNum";
        }
      }
    }
  }
}

.more {
  position: relative;
  min-height: 118px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 12px;
  border: 2px solid #70e2ee;
  margin-top: 20px;
  padding: 20px;
  display: flex;

  .n {
    width: 150px;
  }

  .tabs_ {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .tabs_item {
      width: 23%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #0c3e81;
      border-radius: 5px;
      border: 1px solid #2e82ff;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 0 10px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.yezhu {
  padding: 20px;
  margin-top: 20px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 24px;
  border: 2px solid #70e2ee;
}

.plus1 {
  width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  padding-left: 10px;
}

.plus2 {
  position: absolute;
  left: 80px;
  top: -24px;
  z-index: 99;
}

.isIconbgc {
  background-color: #83a9da;
}

.noIconbgc {
  background-color: #fff;
}

.yema {
  position: absolute;
  bottom: 10px;
  right: 0px;
}

.yema2 {
  position: absolute;
  bottom: 10px;
  right: 0px;
}

::v-deep .el-dialog {
  width: 800px;
  // height: 700px;
  background: url("../../assets/images/dialog_bg2.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;
  color: #fff;
  position: relative;
  // overflow: hidden;

  // display: flex;
  // flex-direction: column;

  // .el-dialog__body{
  //   overflow-x: hidden;
  //   overflow-y: auto;
  //   padding: 15px;

  // }


  table td {
    height: 30px !important;
    line-height: 30px !important;
    border: none;
    border-bottom: 1px solid #07397c;
    cursor: pointer;
  }
}


// ::v-deep .el-dialog {
//   // height: 800px;
//   background: url("../../assets/images/dialog_bg2.png");
//   background-size: 100% 100%;
//   border-radius: 24px;

//   color: #fff;
//   position: relative;
//   overflow: hidden;
// }









::v-deep .el-dialog__title {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}

::v-deep .el-dialog__header {
  margin: 20px;
  border-bottom: 1px solid #338bea;
}

::v-deep .el-tabs__item:hover {
  color: #409eff;
  font-size: 18px;
}

::v-deep .el-tabs__item {
  color: #fff;
  font-size: 18px;
}

::v-deep .el-tabs__item.is-active {
  color: #409eff !important;
}

table {
  table-layout: fixed;
  width: 100%;
  margin: 0;
  color: #fff;
  border-spacing: 0;
}

table tr:nth-child(even) {
  //   background-color: #0f53a5;
}

table td {
  height: 39px;
  border: 1px solid #105db4;
}

table td img {
  width: 47px;
  height: 47px;
}

::v-deep .el-tabs {
  height: 500px !important;
}

// .container {
//   height: 500px;
//   overflow-y: scroll;
// }

.iconImg {
  position: relative;
  top: -2px;
  left: -2px;
  margin-right: 2px;
}
</style>
